// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderMobile_container__2S7Q6","buttons":"HeaderMobile_buttons__jlA2Y","main":"HeaderMobile_main__3P2e_","brandLogo":"HeaderMobile_brandLogo__1HbGt"};